import {Component, OnInit} from '@angular/core';
import {LanguageService} from '../service/language.service';
import {CookieService} from 'ngx-cookie-service';
import {Lang} from '../model/lang.model';
import {Locale} from 'sdv-common';
import {keys} from '../shared/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(public cookieService: CookieService,
              public languageService: LanguageService) {
  }

  ngOnInit() {
  }

  now() {
    return new Date().getFullYear();
  }

  switchLang(language: Lang) {
    const settings = JSON.parse(this.cookieService.get(keys.settings) || '{}');
    if (language.id === Locale.RUSSIAN.id) {
      settings.lang = Locale.RUSSIAN.name;
    } else if (language.id === Locale.UKRAINE.id) {
      settings.lang = Locale.UKRAINE.name;
    } else {
      settings.lang = Locale.ENGLISH.name;
    }
    this.cookieService.set(keys.settings, JSON.stringify(settings));
  }
}
